import React from 'react';
import { Check, Share } from 'lucide-react';
interface ResultStepProps {
  onReset: () => void;
}
export function ResultStep({
  onReset
}: ResultStepProps) {
  return <div className="flex flex-col h-full px-6 py-8 bg-white overflow-y-auto custom-scrollbar" data-id="element-34">
      {/* Success Animation Placeholder */}
      <div className="flex flex-col items-center justify-center mt-4 mb-8" data-id="element-35">
        <div className="w-20 h-20 rounded-full bg-green-50 flex items-center justify-center mb-6 relative" data-id="element-36">
          <div className="absolute inset-0 rounded-full border-4 border-green-500 border-t-transparent animate-spin opacity-20" data-id="element-37"></div>
          <div className="w-14 h-14 rounded-full bg-green-500 flex items-center justify-center text-white shadow-lg shadow-green-500/30" data-id="element-38">
            <Check className="w-8 h-8 stroke-[3]" data-id="element-39" />
          </div>
        </div>

        <h2 className="text-2xl font-bold text-[#1a1a2e] text-center leading-tight mb-2" data-id="element-40">
          Maria, your 3D visualization is ready!
        </h2>
        <p className="text-[#6b7280] text-center text-sm" data-id="element-41">
          We've successfully generated your personalized model.
        </p>
      </div>

      {/* 3D Model Preview Card */}
      <div className="relative w-full aspect-square rounded-2xl border-2 border-[#b8a06a] bg-[#f9fafb] overflow-hidden mb-8 group cursor-pointer shadow-xl shadow-[#b8a06a]/10" data-id="element-42">
        {/* Placeholder for actual 3D canvas */}
        <div className="absolute inset-0 flex flex-col items-center justify-center text-[#b8a06a]" data-id="element-43">
          <div className="w-16 h-16 mb-4 opacity-50" data-id="element-44" />
          <span className="font-semibold text-sm" data-id="element-45">Interactive 3D Preview</span>
          <span className="text-xs opacity-70 mt-1" data-id="element-46">Tap to interact</span>
        </div>

        {/* Decorative elements */}
        <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1.5 rounded-full text-xs font-bold text-[#b8a06a] shadow-sm" data-id="element-47">
          360° View
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-[#b8a06a]/10 to-transparent" data-id="element-48"></div>
      </div>

      {/* Actions */}
      <div className="mt-auto flex flex-col gap-3" data-id="element-49">
        <button className="w-full bg-[#b8a06a] hover:bg-[#a08d5a] text-white font-semibold py-4 rounded-xl transition-colors shadow-lg shadow-[#b8a06a]/20 active:scale-[0.98] flex items-center justify-center gap-2" data-id="element-50">
          <div className="w-5 h-5" data-id="element-51" />
          View my 3D
        </button>

        <button className="w-full bg-white border-2 border-[#e5e7eb] hover:border-[#b8a06a] hover:text-[#b8a06a] text-[#1a1a2e] font-semibold py-3.5 rounded-xl transition-colors flex items-center justify-center gap-2" data-id="element-52">
          <Share className="w-4 h-4" data-id="element-53" />
          Share with your consultant
        </button>

        <button onClick={onReset} className="mt-4 text-sm text-[#6b7280] hover:text-[#1a1a2e] font-medium transition-colors" data-id="element-54">
          Start over
        </button>
      </div>
    </div>;
}